<div id="booking-documents" class="info-accordion">
<div class="pb-3">
  <div class="subtitle_1 txt-darkGray font-14 pb-3">
    <h3 class="subtitle_1">
      {{ 'PROCESSES.ACCOMMODATION.LIST.BOOKING_DOCUMENTS.TITLE' | translate }}
    </h3>
  </div>


    <!--  BOOKING_DOCUMENTS  -->
    <div class="d-flex flex-wrap flex-row">
      <div class="d-flex flex-row align-items-center gap-8 w-50 pb-2">
          <lf-icon name="pass" class="margin-check" width="18px" height="18px" fillColor="#1C69FF"></lf-icon>
        <span class="icon-booking-documents text_1">{{ "COMMON.USER.ID_FILE" | translate }}</span>
      </div>
      <div class="d-flex flex-row align-items-center gap-8 w-100 pb-3">
          <lf-icon name="letter" class="margin-check" width="18px" height="18px" fillColor="#1C69FF"></lf-icon>
        <span class="icon-booking-documents text_1">
          {{ "PROCESSES.ACCOMMODATION.LIST.BOOKING_DOCUMENTS.ACCEPTANCE_LETTER" | translate }}
        </span>
      </div>

      <div class="d-flex flex-row align-items-center gap-8 w-fit-content p-2 bg-grey-custom text_3">
          {{ 'PROCESSES.ACCOMMODATION.LIST.BOOKING_DOCUMENTS.GUARANTOR' | translate }}
          <lf-icon class="d-flex" name="goodUp" width="18px" height="18px" fillColor="#00C49A"></lf-icon>
      </div>
    </div>

</div>
</div>
